import styled, { css } from "styled-components";

import { colors } from "../../consts";
import { IconButton } from "../../components";

const LoaderStyles = css`
  svg {
    width: 32px;
    height: 16px;
  }
`;

export const RefreshButtonStyled = styled(IconButton)`
  width: 32px;
  height: 32px;

  border-radius: 100%;
  background: ${colors.RAISIN_100};

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  ${(props) => props?.isLoading && LoaderStyles};
`;
